import {useCallback, useEffect, useRef} from 'react';

function useEditorSignIn(showSessionNotice: () => void, onAuth: () => void): () => void {
  const latestOnAuth = useRef(onAuth);

  useEffect(() => {
    latestOnAuth.current = onAuth;
  }, [onAuth]);

  return useCallback(() => {
    showSessionNotice();
    latestOnAuth.current();
  }, [showSessionNotice]);
}

export default useEditorSignIn;
